import { useEffect, useState } from 'react';
import { IAdminEventAwardsStore, IAward } from '../../../../../../store/admin/eventAwards/store';

export const useFormattedAwards = (index: number, adminAwards: IAdminEventAwardsStore) => {
  const [awards, setAwards] = useState<IAward[]>([]);

  useEffect(() => {
    if (index && adminAwards && adminAwards[index]) {
      setAwards(
        Object.values(adminAwards[index]).map((award: IAward) => ({
          ...award,
          cash: parseFloat(award.cash as string).toFixed(2),
          points: award.points,
          scrip: parseFloat(award.scrip as string).toFixed(2)
        }))
      );
    }
  }, [index, adminAwards, adminAwards[index]]);

  return [awards];
};
